import { CalendarCheck } from 'lucide-react';
import { MeetingBookedEvent as MeetingBookedEventType } from '../types';
import { formatDate } from '../../utils/dateFormatter';
import EventShell from './EventShell';

interface Props {
  event: MeetingBookedEventType;
}

export default function MeetingBookedEvent({ event }: Props) {
  return (
    <EventShell
      color="red"
      icon={<CalendarCheck className="w-3.5 h-3.5" />}
      title="Meeting Booked"
      timestamp={event.created_at}
    >
      {event.payload.event_name && <p className="font-medium text-foreground">{event.payload.event_name}</p>}
      {event.payload.slot_start && <p>{formatDate(event.payload.slot_start, 'compact')}</p>}
      {event.payload.invitee_name && <p>With: {event.payload.invitee_name}</p>}
    </EventShell>
  );
}
